import { Input } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const MenuListWrapper = styled.div`
  ${Input.S.Input} {
    width: 100%;
  }
`;

const PriceInputContainer = styled.form`
  display: flex;
  flex-direction: row;
  margin-bottom: var(--size-8);
`;

const ActionButtons = styled.div`
  border-top: 1px solid var(--color-components-input-border-default);
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding: 8px 12px;
`;

export { ActionButtons, MenuListWrapper, PriceInputContainer };
